<mat-button-toggle-group [vertical]="true" [(ngModel)]="selectedTagOption">
  <mat-button-toggle
    *ngFor="let tagOption of tagOptions$ | async"
    [value]="$any(tagOption.code)"
    [matTooltip]="tagOption.label"
    [matTooltipDisabled]="!collapsed"
  >
    <div #tagOptionRef [attr.data-tag-option-code]="tagOption.code">
      <i
        class="fa fa-fw swatch"
        [style.background-color]="getDomColorString(tagOption)"
        (mouseenter)="highlight(tagOption.code)"
        (mouseleave)="highlight(undefined)"
      ></i>
      <span [hidden]="collapsed">{{ tagOption.label }}</span>
    </div>
  </mat-button-toggle>
</mat-button-toggle-group>
